<template>
	<header-block title="Buy Card" color="white" bgcolor="#281C3B" border="0"></header-block>
	<CustomerLoadWait :customer="availableVoucher" />
	<transition>
		<div v-if="availableVoucher" class="wrapper">
			<div class="header-image">
				<div class="header" >
					<v-row>
						<img
							class="categoryImage"
							:src="availableVoucher.merchant.category && availableVoucher.merchant.category.buttonImage
								? availableVoucher.merchant.category.buttonImage
								: availableVoucher.merchant.logoUrl"
						/>
					</v-row>
					<v-row class="mt-4">
						<v-col class="v-col-9">
							<h1 class="merchantName">{{ availableVoucher.merchant.name }}</h1>
							<p class="percentage">{{ availableVoucher.effectiveDiscountPercentage }}% cashback</p>
							<v-span v-if="availableVoucher.online" background-color="blue"><img v-if="availableVoucher.online" src="@/assets/online.png" class="online-icon" /> Online</v-span>
							<v-span size="small" v-if="availableVoucher.inStore" variant="outlined"><img v-if="availableVoucher.inStore" src="@/assets/inStore.png" class="in-store-icon" /> In Store</v-span>
							<v-span size="small" style="color: var(--text-color); background: linear-gradient(90deg, #E1C6C8 0%, #FCE5D4 100%);" @click="showDoubleBubble" v-if="availableVoucher.stackWith && availableVoucher.stackWith.length > 0" background-color="blue"><v-icon icon="mdi-circle-double" /> </v-span>
						</v-col>
						<v-col class="v-col-3 icon-col">
							<img :src="availableVoucher.cardUrl" class="icon">
							<FavoriteChip class="favouriteIconChip" :transparent="true" :heartColour="'white'" :isFavorited="availableVoucher.favourite" @favorite-clicked="toggleFavourite" />
						</v-col>
					</v-row>
				</div>
			</div>

			<div class="cart">
				<h2>Value you would like to purchase</h2>
				<v-text-field
					v-if="!availableVoucher.allowedAmounts"
					v-model="amount"
					type="text" 
					inputmode="decimal"
					prefix="£"
					label="Enter amount"
					variant="solo"
					:flat="true"
					clearable
					single-line
					bg-color="white"
					@input="validateAmount"
					:max="availableVoucher.upperAmount"
				></v-text-field>
				<v-select
					v-if="availableVoucher.allowedAmounts"
					v-model="amount"
					prefix="£"
					:items="availableVoucher.allowedAmounts.split(',').map(Number)"
					label="Select amount"
					variant="solo"
					:flat="true"
					clearable
					single-line
					bg-color="white"
				></v-select>
				<v-span :class="['cashback', { 'cashback-zero': !amount || amount <= 0 }]">{{ calcCashback(amount) }}</v-span>
				<p v-if="availableVoucher.lowerAmount && availableVoucher.lowerAmount > 0" class="constraints small">
					Minimum {{formatter.format(availableVoucher.lowerAmount)}}. 
					Maximum {{ formatter.format(availableVoucher.upperAmount) }}. 
					{{ availableVoucher.minorUnit && availableVoucher.minorUnit > 0 ? 'Increments of ' + formatter.format(availableVoucher.minorUnit) : '' }}. 
				</p>
				<v-btn @click="navigateToCart()" :flat="true" class="mt-7 mg-button">Buy now</v-btn>
				<v-alert class="mt-4" density="compact" type="info" variant="outlined" v-if="errorText" :text="errorText" />
				<v-img class="paymentMethods" :src="require('@/assets/payment-methods.png')" />

			</div>

			<div class="howto fromBrand" v-if="availableVoucher.redemptionInstructionsUrl || availableVoucher.faqUrl || availableVoucher.terms">
				<h2>From {{ availableVoucher.merchant.name }}</h2>
				<div class="mt-8" />
				<v-row v-if="availableVoucher.terms">
					<v-col>
						<a @click="toggleDrawer" class="small"><v-icon icon="mdi-information-outline"></v-icon> View Terms and Conditions</a>
					</v-col>
				</v-row>
				<v-row v-if="availableVoucher.faqUrl">
					<v-col>
						<a :href="availableVoucher.faqUrl"><v-icon icon="mdi-link"></v-icon> View Brand's FAQ</a>
					</v-col>
				</v-row>
				<v-row v-if="availableVoucher.redemptionInstructionsUrl">
					<v-col>
						<a :href="availableVoucher.redemptionInstructionsUrl"><v-icon icon="mdi-link"></v-icon> View Brand's Instructions</a>
					</v-col>
				</v-row>
			</div>

			<div class="howto">
				<h2>How it works</h2>
				<ul>
					<li>Enter the value of the voucher you would like to purchase</li>
					<li>Click "Buy Now"</li>
					<li>Make payment</li>
					<li>Your voucher will be added to your account</li>
					<li>Some retail cards need to be "claimed" before they can be used.  Follow the on screen instructions</li>
				</ul>
				<p class="mt-3">* A small Stripe transaction processing fee is added to the purchase price. This allows us to provide you with the full cashback amount without any deductions later.</p>
			</div>

		</div>

	</transition>

	<DrawerPanel ref="termsDrawer" openHeight="70%" bottom="-10px" closedHeight="0" title="Terms and Conditions" backgroundColor="white" openBackgroundColor="white">
		<p v-if="availableVoucher">{{ availableVoucher.terms }}</p>
	</DrawerPanel>

	<DrawerPanel v-if="guide" ref="guideDrawer" openHeight="88%" :closedHeight="_closedDrawerHeightNoMenu()" backgroundColor="white" :bottom="_peekingDrawerBottom_NoMenu()" title="How To Use Guide" 		openBackgroundColor="white">
		<iframe :src="'/#/articles/' + guide.id" style="border: 0px; width: 100%; height: 100%"></iframe>
	</DrawerPanel>

	<DrawerPanel v-if="availableVoucher && availableVoucher.stackWith && availableVoucher.stackWith.length > 0" ref="doubleDrawer" openHeight="70%" bottom="-10px" closedHeight="0" title="What is Double Bubble?" backgroundColor="white" openBackgroundColor="white">
		<div class="simplePage">
			<h1>Double Bubble?</h1>
			<v-icon icon="mdi-circle-double" class="heroImg" />
			<p>Double Bubble allows you to combine a Money Guided cashback voucher with another discount at point of sale to double down on your savings!</p>
			<p>For example, at {{ availableVoucher.merchant.name }}, you may be able to use your {{ availableVoucher.stackWith[0] }} at point of sale and get a discount on your final bill, then use a Money Guided cashback voucher to pay, saving you a lot more!</p>
			<p>Check your {{ availableVoucher.stackWith[0] }} to see what you can combine with Money Guided vouchers at {{ availableVoucher.merchant.name }}.</p>
			<p><small>While we try our best to highlight potential opportunities for Double Bubble, your mileage may vary.</small></p>
		</div>
	</DrawerPanel>
	
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import FavoriteChip from './elements/FavoriteChip.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, DrawerPanel, FavoriteChip},
	data() {
		return {
			useCredit: false,
			amount: null,
			errorText: null,
			pay: false,
			paymentLoading: false,
			paymentResponse: null,
			paymentPending: false,
			voucherResponse: null,
			closable: true,
			showAll: false,
			guide: null
		}
	},
	methods: {

		onLoad: async function() {
			if (this.$route.query.amount !== undefined) {
				this.amount = parseFloat(this.$route.query.amount);
			}
			if (this.$route.query.useSavedToSpend !== undefined) {
				this.useCredit = this.$route.query.useSavedToSpend === 'true' || this.$route.query.useSavedToSpend === true;
			}
			this._getCustomer();
			this._getCustomerVouchers();
			this._getAvailableVoucher(this.$route.params.id, () => {
				this._removeUnavailableDiscountProviders(this.availableVoucher);
				this._getCustomerFavouriteVouchers((f) => {
					if (this.availableVoucher && f && f.length > 0) {
						this.availableVoucher.favourite = f.some(fav => fav.id === this.availableVoucher.id);
					}
				});
				this._getCmsArticleByKey(("VG_" + this.availableVoucher.merchant.name.replaceAll("&",'').toUpperCase()).substring(0,10), (article) => {
					if (article) {
						this.guide = article;
					}
				});
			});
		},

		toggleDrawer: function() {
			this.$refs.termsDrawer.toggleDrawer();
		},

		toggleFavourite: function() {
			if (this.availableVoucher.favourite) {
				this._removeCustomerFavouriteDiscount(this.availableVoucher, () => {
					this.availableVoucher.favourite = false;
				});
			} else {
				this._addCustomerFavouriteDiscount(this.availableVoucher, () => {
					this.availableVoucher.favourite = true;
				});
			}
		},

		showDoubleBubble: function() {
			this.$refs.doubleDrawer.openDrawer();
		},

		validateAmount: function() {
			this.errorText = null;
			if (this.amount && this.availableVoucher.upperAmount && parseFloat(this.amount) > this.availableVoucher.upperAmount) {
				this.amount = this.availableVoucher.upperAmount;
				this.errorText = "Please enter an amount no more than " + this.formatter.format(this.availableVoucher.upperAmount);
			}
			if (this.amount && this.availableVoucher.lowerAmount && parseFloat(this.amount) < this.availableVoucher.lowerAmount) {
				this.errorText = "Please enter an amount at least " + this.formatter.format(this.availableVoucher.lowerAmount);
			}
		},

		validatePayment: function() {
			this.errorText = null;
			if (this.amount == null || this.amount == 0) {
				this.errorText = "Please enter a valid amount";
				return;
			}
			if (this.availableVoucher.lowerAmount && this.availableVoucher.lowerAmount > 0 && (this.amount < this.availableVoucher.lowerAmount || this.amount > this.availableVoucher.upperAmount)) {
				this.errorText = "Please enter an amount between " + this.formatter.format(this.availableVoucher.lowerAmount) + " and " + this.formatter.format(this.availableVoucher.upperAmount);
				return;
			}
			if (this.availableVoucher.minorUnit && this.availableVoucher.minorUnit > 0.01 && (this.amount % this.availableVoucher.minorUnit != 0)) {
				this.errorText = "Please enter an amount in multiples of " + this.formatter.format(this.availableVoucher.minorUnit);
				return;
			}
			this.pay = true;
		},

		calcCashback: function(amount) {
			if (amount && this.availableVoucher && this.availableVoucher.effectiveDiscountPercentage) {
				var cashback = amount * (this.availableVoucher.effectiveDiscountPercentage / 100);
				return this.formatter.format(cashback) + " cashback";
			}
			return "£0 cashback";
		},

		navigateToCart: function() {
			// Validate the amount first
			this.errorText = null;
			if (this.amount == null || this.amount == 0) {
				this.errorText = "Please enter a valid amount";
				return;
			}
			if (this.availableVoucher.lowerAmount && this.availableVoucher.lowerAmount > 0 && (this.amount < this.availableVoucher.lowerAmount || this.amount > this.availableVoucher.upperAmount)) {
				this.errorText = "Please enter an amount between " + this.formatter.format(this.availableVoucher.lowerAmount) + " and " + this.formatter.format(this.availableVoucher.upperAmount);
				return;
			}
			if (this.availableVoucher.minorUnit && this.availableVoucher.minorUnit > 0.01 && (this.amount % this.availableVoucher.minorUnit != 0)) {
				this.errorText = "Please enter an amount in multiples of " + this.formatter.format(this.availableVoucher.minorUnit);
				return;
			}

			// TODO: Create a cart entity and endpoint to store the cart instead of using session storage
			// Store voucher data in session storage for cart persistence
			const cartData = [{
				amount: this.amount,
				availableVoucher: this.availableVoucher,
				meta: { voucherId: this.availableVoucher.id },
				timestamp: new Date().toISOString()
			}];
			this._createCart(cartData);

			// Navigate to cart page with voucher data
			this.$router.push({
				path: '/VoucherCart'
			});
		},

	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>
	.merchantName {
		white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
	}

	.paymentMethods {
		position: relative;
		width: 200px;
		margin: 20px auto 0 auto;
	}

	.cashback {
		background: #FCE5D4;
		color: var(--text-color);
		font-size: 11px;
		padding: 6px 8px;
		border-radius: 4px;
	}

	.cashback-zero {
		background: transparent;
		color: var(--text-color);
		border: 1px solid #FCE5D4;
		border-radius: 4px;
	}

	.icon-col {
		margin-left: -7px;
	}

	.icon {
		width: 72px;
		background-color: #E7ECF7;
		border-radius: 10px;
		margin-top: 10px;
	}	

	.online-icon {
		height: 16px;
		width: 12px;
		margin: 0 auto;
		background-color: transparent;
		filter: invert(1);
	}

	.in-store-icon {
		height: 16px;
		width: 16px;
		margin: 0 auto;
		background-color: transparent;
		filter: invert(1);
	}

	.online-icon + .in-store-icon {
		margin-left: 5px;
	}

	/* Add spacing between the spans when both online and in-store are present */
	v-span:has(.online-icon) + v-span:has(.in-store-icon) {
		margin-left: 10px;
	}

	.icon-col {
		position: relative;
	}

	.favouriteIconChip {
		position: absolute;
		right: -1px;
		top: 80px;
	}

	.categoryImage {
		margin-left: -30px;
		margin-right: -30px;
		margin-top: -10px;
		width: calc(100% + 60px);
		height: 160px;
		object-fit: cover;
	}

	h1 {
		font-size: 24px;
	}
	.header-image {
		margin: -20px -30px 0px -30px;
		background-size: cover;
		margin-top: -138px;
		padding-top: 138px;
		color: white;
		overflow: hidden;
	}
	.v-chip {
		margin-right: 5px;
	}
	.header {
		margin-top: -138px;
		background-color: #281c3be7;
		padding: 30px;
		padding-top: 138px;
		color: white;
		padding-bottom: 200px;
	}
	.logo-col {
		text-align: right;
	}
	.logo-col img {
		width: 70px;
		border-radius: 40px;
		padding: 5px;
		background-color: white;
	}
	.percentage {
		font-size: 16px;
		font-weight: bold;
		margin-top: -5px;
	}
	p{
		font-size: 13px;
	}
	.cart {
		background-color: var(--background-color-alt);
		padding: 30px;
		margin-top: -170px;
		border-radius: 12px;
		padding-bottom: 40px;
		h2 {
			margin-bottom: 15px;
		}
		.constraints {
			margin-top: 10px;
			padding-top: 0px;
		}
		.small {
			font-size: 11px;
		}
		position: relative;
	}
	.howto {
		background-color: var(--background-color-alt);
		padding: 30px;
		margin-top: 20px;
		border-radius: 12px;
		padding-bottom: 35px;
		font-weight: normal;
		font-size: 11px;
		h2 {
			margin-bottom: 15px;
		}
		.constraints {
			margin-top: -10px;
			padding-top: 0px;
		}
		.small {
			font-size: 11px;
		}
		ul{
			padding-left: 20px;
			padding-right: 20px;
			font-size: 11px;
		}
	}
	.fromBrand {
		.v-col {
			padding-top: 0px;
		}
	}
	.cancel{
		position: absolute;
		right: 20px;
		top: 20px;
		
	}
	.descriptionWrapper {
		text-overflow: ellipsis;
		margin-bottom: 5px;
	}

	.wrapper {
		padding-bottom: 30px;
	}

	.simplePage {
		.heroImg {
			font-size: 40px;
			color: var(--text-color);
			margin-top: 20px;
			margin-bottom: 30px;
		}
	}

</style>
